'use strict';

angular.module('webAgro1App').factory('RelacaoCamposService', function ($http) {
  return {
    list: function (filters) {
      var params = {};

      if (filters) {
        params = {
          propriedade: filters.propriedade.id,
          safra: filters.safra.id
        };
      }

      return $http.get(SERVER + '/v1/relacao_campos', {params: params});
    }
  };
});
